const isTranslated = (permission, t) => {
  if (permission === "granted" || permission === "prompt") {
    return t(`scannerFingerprint.permissions.${permission}`);
  }
  return permission;
};

export const getPermissionsStatus = async t => {
  const permissionsList = [
    "accelerometer",
    "accessibility",
    "ambient-light-sensor",
    "camera",
    "clipboard-read",
    "clipboard-write",
    "geolocation",
    "background-sync",
    "magnetometer",
    "microphone",
    "midi",
    "notifications",
    "payment-handler",
    "persistent-storage",
    "push",
  ];

  const permissionsStatus = [];

  for (const permissionName of permissionsList) {
    try {
      const permission = await navigator.permissions.query({
        name: permissionName,
      });
      permissionsStatus.push({
        id: permissionName,
        description: isTranslated(permission.state, t),
      });
    } catch (error) {
      permissionsStatus.push({
        id: permissionName,
        description: t("global.notSupported"),
      });
    }
  }

  return permissionsStatus;
};
